import Swal from 'sweetalert2'
import SignaturePad from 'signature_pad'

$(document).ready(function() {

    const signaturePads = {};

    function initSignaturePad(canvas) {
        const mid = $(canvas).data('mid');
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        signaturePads[mid] = new SignaturePad(canvas, {
            backgroundColor: 'rgba(0,0,0,0)',
            penColor: '#00008B',
        });
    }

    $('.form230-signature-canvas').each(function() {
        initSignaturePad(this);
    });

    $(window).on('resize', function() {
        $('.form230-signature-canvas').each(function() {
            const mid = $(this).data('mid');
            const pad = signaturePads[mid];
            if (!pad) return;
            const data = pad.toData();
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            this.width = this.offsetWidth * ratio;
            this.height = this.offsetHeight * ratio;
            this.getContext('2d').scale(ratio, ratio);
            pad.fromData(data);
        });
    });

    $(document).on('click', '.form230-clear-signature-btn', function() {
        const mid = $(this).data('mid');
        if (signaturePads[mid]) {
            signaturePads[mid].clear();
        }
        $('#form230_signature_' + mid).val('');
        $('#form230_signature_wrapper_' + mid).removeClass('border-danger');
    });

	const form230Widget = {
        isLoading: false,
        init() {
            $(document).on('click', '.submit-form230-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let mid = $(this).data('mid');

			if (_this.isLoading) {
                return false;
            }

			$('.form230-msgs-holder').hide();
            $('.form-form230-home').find('.form-control').removeClass('is-invalid');
            $('.form-form230-home').find('.form-check-input').removeClass('is-invalid');
            $('.form230-signature-wrapper').removeClass('border-danger');

            const pad = signaturePads[mid];
            if (pad && pad.isEmpty()) {
                $('#form230_signature_wrapper_' + mid).addClass('border-danger');
                $('#form230-error-msg-' + mid).html('Semnătura este obligatorie.');
                $('#form230-error-msg-' + mid).fadeIn();
                $('#form230-error-msg-' + mid).delay(5000).fadeOut();
                return false;
            }
            if (pad) {
                $('#form230_signature_' + mid).val(pad.toDataURL('image/png'));
            }

			_this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = '';
            values += 'module_id=' + mid;
            values += '&cnp=' + encodeURIComponent($('#form230_cnp_' + mid).val());
            values += '&birth_date=' + encodeURIComponent($('#form230_birth_date_' + mid).val());
            values += '&last_name=' + encodeURIComponent($('#form230_last_name_' + mid).val());
            values += '&father_initial=' + encodeURIComponent($('#form230_father_initial_' + mid).val());
            values += '&first_name=' + encodeURIComponent($('#form230_first_name_' + mid).val());
            values += '&street=' + encodeURIComponent($('#form230_street_' + mid).val());
            values += '&street_number=' + encodeURIComponent($('#form230_street_number_' + mid).val());
            values += '&building=' + encodeURIComponent($('#form230_building_' + mid).val());
            values += '&staircase=' + encodeURIComponent($('#form230_staircase_' + mid).val());
            values += '&floor=' + encodeURIComponent($('#form230_floor_' + mid).val());
            values += '&apartment=' + encodeURIComponent($('#form230_apartment_' + mid).val());
            values += '&county=' + encodeURIComponent($('#form230_county_' + mid).val());
            values += '&city=' + encodeURIComponent($('#form230_city_' + mid).val());
            values += '&postal_code=' + encodeURIComponent($('#form230_postal_code_' + mid).val());
            values += '&email=' + encodeURIComponent($('#form230_email_' + mid).val());
            values += '&phone=' + encodeURIComponent($('#form230_phone_' + mid).val());
            values += '&fax=' + encodeURIComponent($('#form230_fax_' + mid).val());
            values += '&two_years_option=' + ($('#form230_two_years_option_' + mid).is(':checked') ? 1 : '');
            values += '&marketing_consent=' + ($('#form230_marketing_consent_' + mid).is(':checked') ? 1 : '');
            values += '&data_consent=' + ($('#form230_data_consent_' + mid).is(':checked') ? 1 : '');
            values += '&submit_consent=' + ($('#form230_submit_consent_' + mid).is(':checked') ? 1 : '');
            values += '&privacy=' + ($('#form230_privacy_' + mid).is(':checked') ? 1 : '');
            values += '&signature=' + encodeURIComponent($('#form230_signature_' + mid).val());
            values += '&_token=' + $('meta[name="csrf-token"]').attr('content');

			$.ajax({
                type: 'POST',
                url: baseURL + '/form-230/send',
                data: values,
                success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
                        for (var errorKey in response.errors) {
                            if (!response.errors.hasOwnProperty(errorKey)) continue;
                            for (var error in response.errors[errorKey]) {
                                if (errorKey === 'signature') {
                                    $('#form230_signature_wrapper_' + mid).addClass('border-danger');
                                } else {
                                    $('#form230_' + errorKey + '_' + mid).addClass('is-invalid');
                                }
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
                        $('#form230-error-msg-' + mid).html(errorHtml);
                        $('#form230-error-msg-' + mid).fadeIn();
                        $('#form230-error-msg-' + mid).delay(10000).fadeOut();
                        return false;
                    }

					if (response.status == 1) {
						$('.form-form230-home').find('.form-control').val('');
						$('#form230_privacy_' + mid).prop('checked', false);
                        if (signaturePads[mid]) {
                            signaturePads[mid].clear();
                            $('#form230_signature_' + mid).val('');
                        }

						if (response.pdf_url) {
							const a = document.createElement('a');
							a.href = response.pdf_url;
							a.download = 'formular-230.pdf';
							document.body.appendChild(a);
							a.click();
							document.body.removeChild(a);
						}

						Swal.fire({
							html: response.message
						});

						return false;
					}

					if (response.status == 2) {
						$('#form230-error-msg-' + mid).html(response.message);
                        $('#form230-error-msg-' + mid).fadeIn();
                        $('#form230-error-msg-' + mid).delay(10000).fadeOut();
                    }
                },
                error: function() {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
            });
		}
    };

    if ($('.form-form230-home').length) {
        form230Widget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/form-230.js